import DadosGeraisService from "./DadosGeraisService";

export default {
  mixins: [DadosGeraisService],
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mostrarAccordion: "",
      idRnpPrestador: -1,
      iniciado: false,
      loading: false
    };
  },
  beforeMount() {
    this.recuperarIdRnpPrestador();
  },
  methods: {
    recuperarIdRnpPrestador() {
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
    }
  },
  watch: {
    value() {
      this.mostrarAccordion = this.value === this.$options.name;
    },
    mostrarAccordion() {
      if (this.mostrarAccordion) {
        this.init();
        this.$emit("input", this.$options.name);
        this.$emit("elemento-atual", this.$refs.accordion.$el);
      } else if (this.value === this.$options.name) {
        this.$emit("elemento-atual", null);
        this.$emit("input", "");
      }
    },
    loading() {
      if (!this.mostrarAccordion) return;

      this.$nextTick(() => {
        this.$refs.accordion.resetarAltura();

        if (!this.loading) {
          this.$emit("resetar-scroll");
        }
      });
    }
  }
};
